import { render, staticRenderFns } from "./StampCard.vue?vue&type=template&id=7246ca40&scoped=true&"
import script from "./StampCard.vue?vue&type=script&lang=js&"
export * from "./StampCard.vue?vue&type=script&lang=js&"
import style0 from "./StampCard.vue?vue&type=style&index=0&id=7246ca40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7246ca40",
  null
  
)

export default component.exports